import { dataUnlockSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUnlockSolid = /*#__PURE__*/createIcon(dataUnlockSolid)
export default IconUnlockSolid
